import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ArrowLeftIcon(props) {
	return (
		<svg style={{ marginBottom: "-6px" }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M13.1751 5.12413C13.4756 4.66075 14.0949 4.52869 14.5582 4.82918C15.0216 5.12966 15.1537 5.74891 14.8532 6.21229L13.1751 5.12413ZM10.0142 11.8367L9.16505 12.3649L8.82953 11.8256L9.17513 11.2926L10.0142 11.8367ZM14.8633 17.7384C15.155 18.2073 15.0113 18.824 14.5424 19.1157C14.0734 19.4074 13.4568 19.2638 13.1651 18.7948L14.8633 17.7384ZM14.8532 6.21229L10.8532 12.3808L9.17513 11.2926L13.1751 5.12413L14.8532 6.21229ZM10.8633 11.3085L14.8633 17.7384L13.1651 18.7948L9.16505 12.3649L10.8633 11.3085Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<ArrowLeftIcon fill={props.fill} />
	);
}